// utils.js
export const getNestedValue = (obj, path) => {
  if (!obj || !path) return undefined;
  return path
    .split(".")
    .reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
};

// export const getSanitizedPayload = (data) => {
//   const cleanData = { ...data };
//   Object.keys(cleanData).forEach((key) => {
//     const value = cleanData[key];
//     if (Array.isArray(value)) {
//       cleanData[key] = value.map((v) => (typeof v === "object" ? v._id : v));
//     } else if (value && typeof value === "object" && value._id) {
//       cleanData[key] = value._id;
//     }
//   });
//   return cleanData;
// };

export const getSanitizedPayload = (data, fields = []) => {
  const cleanData = { ...data };

  const getFieldMetaByTopKey = (key) => {
    if (!Array.isArray(fields)) return {};
    // match by top-level key before any dot
    return fields.find((f) => f?.field?.split(".")[0] === key) || {};
  };

  Object.keys(cleanData).forEach((key) => {
    const value = cleanData[key];
    const fieldMeta = getFieldMetaByTopKey(key);
    const type = (fieldMeta.type || "").toLowerCase();

    // Skip complex arrays/sub-structures you handle elsewhere
    if ((type === "array" || type === "substring") && fieldMeta.subFields) {
      return;
    }

    // ✅ Numbers: coerce and default to 0
    if (type === "number") {
      if (value === "" || value == null) {
        cleanData[key] = 0;
      } else {
        const num = Number(value);
        cleanData[key] = Number.isFinite(num) ? num : 0;
      }
      return;
    }

    // Reference array (multi-checkbox)
    if (type === "checkbox" && fieldMeta.array === "true") {
      cleanData[key] = (value || []).map((v) =>
        typeof v === "object" && v?._id ? v._id : v
      );
      return;
    }

    // Single ObjectId reference (dropdown)
    if (value && typeof value === "object" && value._id) {
      cleanData[key] = value._id;
      return;
    }

    // Fallback for arrays
    if (Array.isArray(value)) {
      cleanData[key] = value.map((v) =>
        typeof v === "object" && v?._id ? v._id : v
      );
    }
  });

  // ✅ Ensure *missing* number fields also exist as 0 (e.g., user never touched them)
  (fields || []).forEach((f) => {
    if ((f?.type || "").toLowerCase() === "number") {
      const topKey = f.field?.split(".")[0];
      if (
        topKey &&
        (cleanData[topKey] === undefined ||
          cleanData[topKey] === "" ||
          cleanData[topKey] == null)
      ) {
        cleanData[topKey] = 0;
      }
    }
  });

  return cleanData;
};
